import React from 'react';
import { Navigate } from 'react-router';
import Base from '../../Base';
import SelectAsync from 'react-select/async';

export default class EmployeeEnterExit extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            data: props.Data,
            loading: true,
            personId: null,
            personName: '',
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
    }
    enter(e) {
        if (!this.isNull(e)) e.preventDefault();

        this.httpPost("api/v1/employeeenterexit/enter", {
            personId: this.state.personId,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    exit(e) {
        if (!this.isNull(e)) e.preventDefault();

        this.httpPost("api/v1/employeeenterexit/exit", {
            personId: this.state.personId,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">ورود و خروج</h4>
                        </div>
                        {this.renderBody()}
                    </div>
                </div>
            </div>
        </div>
    }
    renderBody() {
        return [
            <div className="modal-body">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3">
                            <div className="form-group">
                                <label className="form-label">شخص مورد نظر</label>
                                <div className="form-control-wrap">
                                    <SelectAsync
                                        isClearable={false}
                                        defaultValue={this.state.personId == null ? null : [{ value: this.state.personId, label: this.state.personName }]}
                                        isMulti={false}
                                        placeholder="شخص مورد نظر"
                                        defaultOptions
                                        loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback)}
                                        onChange={e => {
                                            this.state.personId = e.value;
                                            this.state.personName = e.label;
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>,
            <div className="modal-footer">
                <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}><span className="shortcut">Esc - </span>انصراف</button>
                <button type="submit" onClick={e => this.enter(e)} className="btn btn-success">
                    <span className="shortcut"></span> ورود
                </button>
                <button type="submit" onClick={e => this.exit(e)} className="btn btn-danger">
                    <span className="shortcut"></span> خروج
                </button>
            </div>
        ];
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.state.inline ? this.renderBody() : this.renderForm()
            ];

        return contents;
    }
}